module.exports = __webpack_public_path__ + "img/cloud02.61ce0758.png";